import cx from 'classnames';
import { kebabCase } from 'lodash';

/**
 * Simplifies applying bem modifiers to an element
 * @param {string} elementName - base class name of the element (or block)
 * @param {string|array|object} modifiers - modifier or a list of modifiers, with optional boolean values
 * @param {string} additionalClassName - additional non-bem class(es) (please consider moving these styles to a mixin)
 * @returns {string} compiled list of class names
 */
const bem = (elementName, modifiers, additionalClassName = '') => {
  const type = typeof modifiers;

  if (type === 'undefined') {
    return `${elementName} ${additionalClassName}`;
  }

  if (type === 'string') {
    return `${elementName} ${elementName}--${kebabCase(
      modifiers
    )} ${additionalClassName}`;
  }

  const isArray = Array.isArray(modifiers);
  const keys = isArray ? modifiers : Object.keys(modifiers);

  const modifiedClassNames = keys.reduce(
    (obj, key) =>
      (key
        ? {
            ...obj,
            [`${elementName}--${kebabCase(key)}`]: isArray
              ? true
              : modifiers[key],
          }
        : obj),
    {}
  );

  return cx(elementName, modifiedClassNames, additionalClassName);
};

export default bem;
